module.exports = __webpack_public_path__ + "img/diamond-icon.557853d2.svg";